const images = [
  {
    key: "commercial",
    img: "https://i.imgur.com/e2RrQAh.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/gawfJK6.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/bs5WizA.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/wJULtR1.jpg",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/DUYscUQ.png",
  },
  {
    key: "interior",
    img: "https://i.imgur.com/kOPNwcV.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/uelGCQA.png ",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/VzQuNF0.jpg",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/wIPUReA.jpg",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/pNBzio1.jpg",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/PUwD8pV.png",
  },
  {
    key: "interiors",
    img: "https://i.imgur.com/ek28h0Q.jpg",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/rAJGXgi.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/UzIpbzC.png",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/dvoBr1s.png",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/N9vLpqd.png",
  },
  {
    key: "interiors",
    img: "https://i.imgur.com/43yC9Wt.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/o7kptmW.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/4NXkTKK.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/YynNv4I.jpg",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/uKobaFp.png",
  },
  {
    key: "residential",
    img: "https://i.imgur.com/BXINcgx.png",
  },
  {
    key: "interiors",
    img: "https://i.imgur.com/gSYpjP3.jpg",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/UmqtNbC.jpg",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/XwPvZ9K.png",
  },
  {
    key: "commercial",
    img: "https://i.imgur.com/wGRPJ79.png",
  },
];

export default images;
